import React, { FC } from "react";

import { CategoryCard } from "@/components/molecules";
import { InsuredGoodCategory } from "@/shared/domain";

import { InsuredGoodRootCategory } from "../../utils/InsuredGoodRootCategory";

type InsuredGoodCategoryCardProps = {
    category: InsuredGoodCategory;
    onCategoryClick: () => void;
};

export const InsuredGoodCategoryCard: FC<InsuredGoodCategoryCardProps> = ({ category, onCategoryClick }) => {
    return (
        <CategoryCard
            id={category.category.id}
            name={category.category.name}
            icon={InsuredGoodRootCategory.getFromId(category.category.id).cardIcon}
            count={category.totalItems}
            testPrefix="insured_good_category_card-button"
            onClick={onCategoryClick}
        />
    );
};

export default InsuredGoodCategoryCard;
